import script from "./SmsConversation.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsConversation.vue?vue&type=script&setup=true&lang=js"

import "./SmsConversation.vue?vue&type=style&index=0&id=00ec5ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ec5ba4"]])

export default __exports__